import { gql } from '@apollo/client';

const EDIT_USER_LICENSE = gql`
  mutation EditUserLicense($user: EditUserLicenseInput!) {
    editUserLicense(user: $user)
  }
`;

export default EDIT_USER_LICENSE;
